export default {
  USABLE: "0", // 利用可
  UNUSABLE: "1" // 利用不可
}
